import * as preact from 'preact'
const { h, Component } = preact
import * as style from './style.css'
import PureComponent from '../../../lib/preact-pure-component'
import classNames from 'classnames'
import { createImageUrl } from '../../../lib/serum-imagecrop'

interface Props {
  roles: Role[]
}

interface Role {
  name: string
  role: string
  image: string
}

export class BylineInline extends PureComponent<Props, {}> {
  render() {
    const { roles } = this.props
    const mappedRoles = roles.map(role => {
      const imgUrl = createImageUrl({ id: role.image, width: 300, quality: 0.6 })
      return (
        <div className={style.innerWrapper} key={role.name}>
          <div className={style.imgWrapper} aria-hidden="true">
            <img src={imgUrl} className={style.image} />
          </div>
          <dl className={style.list}>
            <dt className={style.role}>{role.role}</dt>
            <dd className={style.name}>{role.name}</dd>
          </dl>
        </div>
      )
    })
    return <div className={style.wrapper}>{mappedRoles}</div>
  }
}
